class UploadableFile {
  constructor(file) {
    const reader = new FileReader();

    reader.addEventListener("load", () => {
      this.base64 = reader.result;
    });

    reader.readAsDataURL(file);

    this.file = file;
    this.id = `${file.name}-${file.size}-${file.lastModified}-${file.type}`;
    this.url = URL.createObjectURL(file);
  }
}

export default {
  data() {
    return {
      files: []
    };
  },
  methods: {
    fileExists(otherId) {
      return this.files.some(({ id }) => id === otherId);
    },
    addFiles(newFiles) {
      let newUploadableFiles = [...newFiles]
        .filter(file => /\.(gif|jpe?g|png|webp)$/i.test(file.name))
        .map(file => new UploadableFile(file))
        .filter(file => !this.fileExists(file.id));

      this.files = this.files.concat(newUploadableFiles);
    },
    removeFile(file) {
      const index = this.files.indexOf(file);

      if (index > -1) this.files.splice(index, 1);
    }
  }
};
